import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/Button";

interface Props {
  rangeLabel: string;
  canPrev: boolean;
  canNext: boolean;
  hasPrevMonth: boolean;
  hasNextMonth: boolean;
  onPrev: () => void;
  onNext: () => void;
}

// Prev / "Sep 14 – Sep 30" / Next control for the By Day grid window.
export default function DayWindowStepper({ rangeLabel, canPrev, canNext, hasPrevMonth, hasNextMonth, onPrev, onNext }: Props) {
  return (
    <div className="inline-flex items-center gap-2">
      <Button
        variant="outline"
        size="icon"
        className="h-7 w-7"
        disabled={!canPrev && !hasPrevMonth}
        onClick={onPrev}
        aria-label={canPrev ? "Previous days" : "Previous month"}
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <span
        style={{ color: "var(--muted-foreground)" }}
        className="text-xs font-medium tabular-nums whitespace-nowrap min-w-[110px] text-center"
      >
        {rangeLabel}
      </span>
      <Button
        variant="outline"
        size="icon"
        className="h-7 w-7"
        disabled={!canNext && !hasNextMonth}
        onClick={onNext}
        aria-label={canNext ? "Next days" : "Next month"}
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
}
